import { createFileRoute } from '@tanstack/react-router';
import SubscriptionCards from '@/lib/subscription/components/SubscriptionCards';
import { Card, CardFooter, CardHeader } from '@heroui/react';

export const Route = createFileRoute('/pricing')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <div className=' mb-16 grid  grid-flow-row '>
            <div className='mx-auto mt-2 grid h-min gap-y-3  md:max-w-7xl '>
                <div className='gap-2 justify-self-center  text-center'>
                    <h1 className=' bg-linear-to-r from-green-500 to-teal-500 bg-clip-text pb-4 text-5xl font-bold tracking-tight text-transparent'>
                        Caddy Stats - Pricing
                    </h1>
                </div>
                <SubscriptionCards />
                <div className=' grid items-center gap-2  px-2 md:mx-auto md:w-1/2'>
                    <Card className=' text-lg '>
                        <CardHeader className='text-center text-3xl font-semibold '>
                            <div className='flex w-full justify-center text-center'>
                                Have a custom requirement or coach multiple teams?
                            </div>
                        </CardHeader>
                        <CardFooter className='text-center'>
                            <div className='w-full justify-center text-center'>
                                Please reach out to{' '}
                                <a
                                    href={'mailto:cade@caddystats.golf'}
                                    className=' font-semibold text-green-500'>
                                    cade@caddystats.golf
                                </a>{' '}
                                for a custom quote or help!
                            </div>
                        </CardFooter>
                    </Card>
                </div>
            </div>
        </div>
    );
}
